module.exports = __webpack_public_path__ + "601f4138cb1277bdc292f6d3909342e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/header-bg.jpg
// module id = 275
// module chunks = 0